import { customerSiteURL } from "../Services/api/baseURL";
import slugify from "./slugify";

const normalizeBase = () => customerSiteURL.replace(/\/$/, "");

const joinPath = (...segments) =>
  segments
    .flatMap((segment) => String(segment ?? "").split("/"))
    .map((part) => part.trim())
    .filter(Boolean)
    .join("/");

export const buildCustomerSiteUrl = (...pathSegments) => {
  const path = joinPath(...pathSegments);
  const base = normalizeBase();
  return path ? `${base}/${path}` : base;
};

export const getProductSeoPreviewUrl = (variant) => {
  const slug = variant?.slug || slugify(variant?.variantName);
  return slug ? buildCustomerSiteUrl("products", slug) : undefined;
};

export const getBrandSeoPreviewUrl = ({ slug, brandName } = {}) =>
  buildCustomerSiteUrl("brand", slug || slugify(brandName) || "{slug}");

export const getCollectionSeoPreviewUrl = ({ slug, name } = {}) => {
  const segment = slug || slugify(name);
  return segment ? buildCustomerSiteUrl("collections", segment) : undefined;
};

export const getSubCollectionSeoPreviewUrl = ({
  categorySlug,
  subSlug,
  subName,
} = {}) => {
  const sub = subSlug || slugify(subName);
  if (!sub) return undefined;
  return buildCustomerSiteUrl(
    "collections",
    categorySlug || "category",
    sub
  );
};

export const getStaticPageSeoPreviewUrl = (path) => {
  if (!path) return undefined;
  if (path === "/") return normalizeBase();
  const normalized = path.startsWith("/") ? path.slice(1) : path;
  return buildCustomerSiteUrl(normalized);
};
